import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import { API_URL } from "../../../Helpers/urls";
import SubscriptionCard from "../../Layout/SubscriptionCard";
import Button from "../../Layout/Button";
import ArrowAnimation from "../../Layout/ArrowAnimation";

const SubscriptionsPageConfirm = ({
  onClickCancel,
  currentSubcription,
  newSubscription,
  updateShow,
  updateConfirm,
  setSnack,
  subscriptionSubModel
}) => {
  const { viewerObj, setViewerObj, connectedStripeId } =
    useContext(GlobalContext);
  const { phase } = viewerObj.subscription;

  const displayContent = ({ ...item }) => {
    return (
      <SubscriptionCard
        {...item}
        cardStyle={{ display: "flex", height: "auto", width: "100%", flex: 1 }}
      />
    );
  };
  const updateSubscription = async () => {
    updateShow(true);
    const { data, error } = await axios.post(`${API_URL}/update-subscription`, {
      price_Id:
        phase?.scheduling &&
        phase.scheduling == "downgrade" &&
        newSubscription?.price_Id == phase.price_Id
          ? currentSubcription.price_Id
          : newSubscription.price_Id,
      product_Id: newSubscription.product_Id,
      subscriptionId: viewerObj.subscription.id,
      subModel:subscriptionSubModel,
      ...(subscriptionSubModel == 'tier' && {newSubscriptionPrice: parseInt(newSubscription.price)}),
      connectedStripeId,
    });
    console.log(data?.data, error);
    if (data) {
      if (data?.data)
        setViewerObj({ ...viewerObj, subscription: data.data.subscription });
      if (data?.message)
        setSnack({ show: true, type: "success", message: data?.message });
      updateConfirm(false);
    }
    setTimeout(() => updateShow(false), 100);
  };

  const removeSubscription = async () => {
    updateShow(true);
    const { data, error } = await axios.post(
      `${API_URL}/schedule-subscription-deletion`,
      {
        subscriptionId: viewerObj.subscription.id,
        connectedStripeId,
      }
    );
    if (data) {
      if (data?.data)
        setViewerObj({ ...viewerObj, subscription: data.data.subscription });
      if (data?.message)
        setSnack({ show: true, type: "success", message: data?.message });
      updateConfirm(false);
    }
    setTimeout(() => updateShow(false), 100);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="h5" className="subscription-heading">
        Confirm
      </Typography>
      {currentSubcription?.price < newSubscription?.price && (
        <>
          <div
            className="card-detail-container"
            style={{ marginTop: 10, marginBottom: 10 }}
          >
            <p
              className="sub-heading"
              style={{
                marginBottom: 2,
                fontSize: 18,
                fontWeight: "bold",
                textAlign: "start",
              }}
            >
              NOTE:
            </p>
            <p
              className="sub-heading"
              style={{
                marginBottom: 2,
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "start",
              }}
            >
              - Your new plan starts today.
            </p>
            <p
              className="sub-heading"
              style={{
                marginBottom: 2,
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "start",
              }}
            >
              - We’ll apply the remainder of this month’s bill to your new plan.
              Your new billing date is the day that credit runs out.
            </p>
          </div>
        </>
      )}
      <div
        style={{ display: "flex", flex: 1, justifyContent: "space-between" }}
      >
        {displayContent(currentSubcription)}
        {newSubscription && (
          <div
            style={{
              display: "flex",
              flex: 1,
              position: "relative",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArrowAnimation />
          </div>
        )}
        {newSubscription && displayContent(newSubscription)}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      >
        <Button
          onClick={onClickCancel}
          buttonStyle={{ backgroundColor: "red" }}
          buttonText={"Cancel"}
        />
        <Button
          onClick={newSubscription ? updateSubscription : removeSubscription}
          glow
          buttonText={
            phase?.scheduling &&
            (newSubscription?.price_Id == phase.price_Id ||
              (!newSubscription && phase.scheduling == "cancelation"))
              ? `Undo ${phase?.scheduling}`
              : `Confirm`
          }
        />
      </div>
    </div>
  );
};

export default SubscriptionsPageConfirm;
